import {ErrorHollowIcon, ParameterIcon, TagIcon} from 'src/icons';
import {DiverImage, EmptyParametersImage} from 'src/images';

export enum ETab {
  RESTRICRICTIONS = 'restrictions',
  TAGS = 'tags',
  PARAMETERS = 'parameters',
}

export const TABS = Object.values(ETab);
export const AUTHORIZED_TABS = [ETab.TAGS, ETab.PARAMETERS];

export const tabIconHash = {
  [ETab.TAGS]: TagIcon,
  [ETab.PARAMETERS]: ParameterIcon,
  [ETab.RESTRICRICTIONS]: ErrorHollowIcon,
};

export const emptyTabIconHash = {
  [ETab.TAGS]: DiverImage,
  [ETab.PARAMETERS]: EmptyParametersImage,
  [ETab.RESTRICRICTIONS]: () => null,
};
